import "core-js/modules/es.string.trim";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getOnlineShopOrderList, onlineShopOrderFind, deleteOnlineShopOrder, updateOnlineShopOrder, getSellerList } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { getDict } from '@/utils/dictionary'; // 获取字典数据的func

var _this;

export default {
  name: 'OnlineShopOrderManage',
  components: {},
  filters: {
    formatDate: function formatDate(time) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm:ss';

      if (time != null && time !== '') {
        return formatTimeToStr(time, format);
      }

      return '';
    },
    formatDate2: function formatDate2(time) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yy-MM-dd hh:mm';

      if (time != null && time !== '') {
        return formatTimeToStr(time, format);
      }

      return '';
    },
    getSellerName: function getSellerName(id) {
      for (var i = 0; i < _this.sellerOptions.length; i++) {
        if (_this.sellerOptions[i].sellerId == id) {
          return _this.sellerOptions[i].sellerName;
        }
      }

      return '';
    },
    getLogisticsStatusName: function getLogisticsStatusName(value) {
      for (var i = 0; i < _this.logisticsStatusOptions.length; i++) {
        if (_this.logisticsStatusOptions[i].value == value) {
          return _this.logisticsStatusOptions[i].label;
        }
      }

      return '';
    },
    getPayStatusName: function getPayStatusName(value) {
      for (var i = 0; i < _this.payStatusOptions.length; i++) {
        if (_this.payStatusOptions[i].value == value) {
          return _this.payStatusOptions[i].label;
        }
      }

      return '';
    },
    getExchangeStatusName: function getExchangeStatusName(value) {
      for (var i = 0; i < _this.exchangeStatusOptions.length; i++) {
        if (_this.exchangeStatusOptions[i].value == value) {
          return _this.exchangeStatusOptions[i].label;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getOnlineShopOrderList,
      tableData: [],
      type: '',
      logisticsUpdateVisible: false,
      logisticsSellerUpdateVisible: false,
      refundUpdateVisible: false,
      remarkUpdateVisible: false,
      formData: {},
      expandRowKeys: [],
      sellerOptions: [],
      payStatusOptions: [],
      logisticsStatusOptions: [],
      exchangeStatusOptions: [],
      logisticSupplierOptions: []
    };
  },
  computed: {},
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var sellerOptions, configRes;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getSellerList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 2:
                sellerOptions = _context3.sent;
                _this3.sellerOptions = sellerOptions.data.list;
                _this3.searchInfo.sellerId = _this3.sellerOptions[0].sellerId;
                _context3.next = 7;
                return getDict('onlinePayStatus');

              case 7:
                _this3.payStatusOptions = _context3.sent;
                _context3.next = 10;
                return getDict('onlineshopExchangeStatus');

              case 10:
                _this3.exchangeStatusOptions = _context3.sent;
                _context3.next = 13;
                return getDict('onlineshopLogisticsStatus');

              case 13:
                _this3.logisticsStatusOptions = _context3.sent;

                _this3.logisticsStatusOptions.sort(function (a, b) {
                  return a.value - b.value;
                });

                _context3.next = 17;
                return _this3.filterDictItemLabel(4, 'onlineshopConfig');

              case 17:
                configRes = _context3.sent;
                _this3.logisticSupplierOptions = JSON.parse(configRes);
                _this3.formData = _this3.initData();
                _context3.next = 22;
                return _this3.getTableData();

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    initData: function initData() {
      return {
        mainOrderNo: '',
        logisticsType: 0,
        logisticsStatus: 0,
        logisticsSupplierName: '',
        logisticsBillNo: '',
        refundLogisticsSupplierName: '',
        refundLogisticsBillNo: '',
        logisticsSellerId: 0,
        logisticsSellerOptions: [],
        refundStatus: 2,
        refundType: 2,
        remark: ''
      };
    },
    onSearch: function onSearch() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
      this.expandRowKeys = [];
    },
    onReset: function onReset() {
      this.searchInfo = {
        sellerId: this.sellerOptions[0].sellerId
      };
      this.onSearch();
    },
    getRowKey: function getRowKey(row) {
      return row.mainOrderNo;
    },
    onRowClick: function onRowClick(row, column) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(column.label === '操作')) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                if (row.hasExpand) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 5;
                return onlineShopOrderFind({
                  'mainOrderNo': row.mainOrderNo
                });

              case 5:
                res = _context4.sent;

                if (res.code == 0) {
                  row.hasExpand = true;
                  row.orderDetail = res.data;
                }

              case 7:
                if (_this4.expandRowKeys.length > 0 && row.mainOrderNo === _this4.expandRowKeys[0]) {
                  _this4.expandRowKeys = [];
                } else {
                  _this4.expandRowKeys = [row.mainOrderNo];
                }

                row.logisticsTimeLine = _this4.getLogisticsTimeLine(row);

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    getLogisticsTimeLine: function getLogisticsTimeLine(row) {
      var logisticsTimeLine = [];

      for (var i = 0; i < this.logisticsStatusOptions.length; i++) {
        var content = this.logisticsStatusOptions[i].label;
        var billNo = '';

        if (this.logisticsStatusOptions[i].value == 2 && row.logisticsBillNo) {
          content += '【' + row.logisticsSupplierName + '-' + row.logisticsBillNo + '】';
          billNo = row.logisticsBillNo;
        }

        if (this.logisticsStatusOptions[i].value == 12 && row.refundLogisticsBillNo) {
          content += '【' + row.refundLogisticsSupplierName + '-' + row.refundLogisticsBillNo + '】';
          billNo = row.logisticsBillNo;
        }

        if (row.logisticsStatus <= 3 && this.logisticsStatusOptions[i].value <= 3) {
          logisticsTimeLine.push({
            content: content,
            type: this.logisticsStatusOptions[i].value <= row.logisticsStatus ? 'primary' : '',
            icon: 'el-icon-truck',
            billNo: billNo
          });
        }

        if (row.logisticsStatus > 3) {
          logisticsTimeLine.push({
            content: content,
            type: this.logisticsStatusOptions[i].value <= row.logisticsStatus ? 'primary' : '',
            icon: 'el-icon-truck',
            billNo: billNo
          });
        }
      }

      return logisticsTimeLine;
    },
    // 查看快递
    onViewBill: function onViewBill(item) {
      debugger;

      if (item.billNo) {
        window.open('https://www.baidu.com/s?wd=' + item.billNo);
      }
    },
    // 查看优惠券详情
    onViewTicket: function onViewTicket(item) {
      var params = {
        ticketRuleNo: item.ticketRuleNo
      };

      if (item.ruleType === 2) {
        this.$router.push({
          name: 'OilTicketConfig',
          params: params
        });
      }

      if (item.ruleType === 3) {
        this.$router.push({
          name: 'GoodsTicketConfig',
          params: params
        });
      }
    },
    onDelete: function onDelete(row) {
      var _this5 = this;

      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return deleteOnlineShopOrder({
                  'mainOrderNoList': [row.mainOrderNo]
                });

              case 2:
                _this5.getTableData();

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))).catch(function (err) {});
    },
    onUpdate: function onUpdate(row) {
      this.formData.mainOrderNo = row.mainOrderNo;
      this.formData.logisticsType = row.logisticsType;
      this.formData.logisticsSellerId = row.logisticsSellerId;
      this.formData.logisticsSupplierName = row.logisticsSupplierName;
      this.formData.logisticsBillNo = row.logisticsBillNo;
      this.formData.logisticsStatus = row.logisticsStatus;
      this.formData.refundLogisticsSupplierName = row.refundLogisticsSupplierName;
      this.formData.refundLogisticsBillNo = row.refundLogisticsBillNo;
      this.formData.refundType = row.refundType;
      this.formData.remark = row.remark;
    },
    // 确认收货
    onLogisticsOk: function onLogisticsOk(row) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this6.onUpdate(row);

                _this6.$confirm('确认用户已收货？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                  var res;
                  return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          _this6.formData.logisticsStatus = 3;
                          _context6.next = 3;
                          return updateOnlineShopOrder(_objectSpread({
                            'dataType': 1
                          }, _this6.formData));

                        case 3:
                          res = _context6.sent;

                          if (res.code == 0) {
                            _this6.closeDialog();
                          }

                        case 5:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6);
                }))).catch(function (err) {
                  debugger;

                  _this6.closeDialog();
                });

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    handleCommand: function handleCommand(command) {
      if (command.action === 'logisticsOk') {
        this.onLogisticsOk(command.row);
      }

      if (command.action === 'updateRemark') {
        this.remarkUpdateVisible = true;
        this.onUpdate(command.row);
      }

      if (command.action === 'delete') {
        this.onDelete(command.row);
      }
    },
    closeDialog: function closeDialog() {
      this.getTableData();
      this.formData = this.initData();
      this.remarkUpdateVisible = false;
      this.logisticsUpdateVisible = false;
      this.logisticsSellerUpdateVisible = false;
      this.refundUpdateVisible = false;
    },
    enterLogisticsDialog: function enterLogisticsDialog() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(_this7.formData.logisticsSupplierName.trim() == '')) {
                  _context8.next = 3;
                  break;
                }

                _this7.$message({
                  type: 'warning',
                  message: '快递公司不能为空！'
                });

                return _context8.abrupt("return");

              case 3:
                if (!(_this7.formData.logisticsBillNo.trim() == '')) {
                  _context8.next = 6;
                  break;
                }

                _this7.$message({
                  type: 'warning',
                  message: '快递单号不能为空！'
                });

                return _context8.abrupt("return");

              case 6:
                _context8.next = 8;
                return updateOnlineShopOrder(_objectSpread({
                  'dataType': 1
                }, _this7.formData));

              case 8:
                res = _context8.sent;

                if (res.code == 0) {
                  _this7.closeDialog();
                }

              case 10:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    enterLogisticsSellerDialog: function enterLogisticsSellerDialog() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var res;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return updateOnlineShopOrder(_objectSpread({
                  'dataType': 1
                }, _this8.formData));

              case 2:
                res = _context9.sent;

                if (res.code == 0) {
                  _this8.closeDialog();
                }

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    enterRefundDialog: function enterRefundDialog(dataType) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var that, res, _res;

        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                that = _this9;

                if (!(that.formData.refundStatus === 3)) {
                  _context11.next = 7;
                  break;
                }

                _context11.next = 4;
                return updateOnlineShopOrder(_objectSpread({
                  'dataType': dataType
                }, _this9.formData));

              case 4:
                res = _context11.sent;

                if (res.code == 0) {
                  _this9.closeDialog();
                }

                return _context11.abrupt("return");

              case 7:
                if (!(that.formData.refundStatus === 2 && dataType === 1)) {
                  _context11.next = 14;
                  break;
                }

                // 通过、保存
                _this9.formData.logisticsStatus = that.formData.refundLogisticsBillNo.trim() !== '' ? 12 : 11;
                _context11.next = 11;
                return updateOnlineShopOrder(_objectSpread({
                  'dataType': dataType
                }, _this9.formData));

              case 11:
                _res = _context11.sent;

                if (_res.code == 0) {
                  _this9.closeDialog();
                }

                return _context11.abrupt("return");

              case 14:
                if (!(that.formData.refundStatus === 2 && dataType === 2)) {
                  _context11.next = 17;
                  break;
                }

                // 通过、退款
                _this9.$confirm('您正在发起退款操作，将原路退回给用户，确定操作吗？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                  var res;
                  return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                      switch (_context10.prev = _context10.next) {
                        case 0:
                          _this9.formData.logisticsStatus = 20;
                          _context10.next = 3;
                          return updateOnlineShopOrder(_objectSpread({
                            'dataType': dataType
                          }, _this9.formData));

                        case 3:
                          res = _context10.sent;

                          if (res.code == 0) {
                            _this9.closeDialog();
                          }

                        case 5:
                        case "end":
                          return _context10.stop();
                      }
                    }
                  }, _callee10);
                }))).catch(function (err) {
                  _this9.closeDialog();
                });

                return _context11.abrupt("return");

              case 17:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    },
    // 更新备注
    enterRemarkDialog: function enterRemarkDialog() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var res;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return updateOnlineShopOrder(_objectSpread({
                  'dataType': 1
                }, _this10.formData));

              case 2:
                res = _context12.sent;

                if (res.code == 0) {
                  _this10.closeDialog();
                }

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }))();
    }
  }
};